import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import connectionErrorSvg from 'assets/connection-error.svg';
import { ErrorPage } from 'components/error-page/error-page.component';

export const LoginErrorPage = ({
  onButtonClick,
}: {
  onButtonClick?: () => void;
}) => {
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' }));

  return (
    <ErrorPage
      imageSrc={connectionErrorSvg}
      headingString={formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' })}
      bodyString={formatMessage(
        { id: 'STR_LOGIN_ERROR_BODY' },
        { appName: formatMessage({ id: 'STR_APP_NAME' }) },
      )}
      buttonText={formatMessage({ id: 'STR_TRY_AGAIN' })}
      onButtonClick={onButtonClick}
    />
  );
};
